import { BlockingModal } from 'components/BlockingModal/BlockingModal';
import React from 'react';

import styled from 'styled-components';

const Content = styled.div`
  padding: 24px;
  color: #414141;

  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
`;

interface IProps {
  open: boolean;
  dismissCallback: () => void;
  endGameCallback: () => void;
}

const EndGameModal: React.FC<IProps> = (props) => {
  const { open, dismissCallback, endGameCallback } = props;

  return (
    <BlockingModal
      open={open}
      onClose={dismissCallback}
      title='End this game?'
      confirmBtn={{
        intent: 'primary',
        label: 'End game',
        onClick: endGameCallback,
        width: '141px',
      }}
      cancelBtn={{
        intent: 'tertiary',
        label: 'Cancel',
        onClick: dismissCallback,
        width: '141px',
        // @ts-ignore
        ['data-test']: 'end-game-modal-button',
        style: {
          backgroundColor: '#F5F5F5',
          color: '#414141',
        },
      }}
      maxWidth='xs'
      fullWidth
    >
      <Content>A game cannot be resumed once it has been ended.</Content>
    </BlockingModal>
  );
};

export default EndGameModal;
